/* eslint-disable  */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
// @ts-nocheck
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Grid,
  Box,
  Button,
  IconButton,
  Typography,
  Popover,
  List,
  ListItem,
  Link,
  Divider,
  SwipeableDrawer,
  Paper,
  Tab,
  Tabs,
} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TurnedInNotRoundedIcon from '@mui/icons-material/TurnedInNotRounded';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import './Header.styles.css';
import MainLogo from '../components/MainLogo/MainLogo.components';
import UpdateEmail from './UpdateEmail';
import AccountDetail from './User/AccountDetails/AccountDetails.screen';
import ChangePassword from './User/ChangePassword/ChangePassword.screen';
import BottomDrawer from '../components/BottomDrawer/BottomDrawer';
import SignIn from './User/SignIn/SignIn.screen';
import { useAppSelector } from '../store/hooks';
import { useLogin } from './User/hooks/useLogin';
import AccountDetails from './User/AccountDetails/AccountDetails.screen';
import { useRoomScene } from './User/hooks/useRoomScene';
import ExitWithoutSavingModal from './User/ExitWithoutSaving/ExitWithoutSavingModal.screen';
// Start Tab Code
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ div: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

const Header = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { logout } = useLogin();
  const { userData } = useAppSelector((state) => state.user);

  const opensecond = Boolean(anchorEl);
  const id = opensecond ? 'simple-popover' : undefined;

  const [openDrawer, setOpenDrawer] = React.useState(false);

  const [page, setPage] = React.useState<boolean>(0);

  const { getRoomScene } = useRoomScene();

  const toggleDrawer = (tab = null) => {
    if (tab === 1) {
      getRoomScene();
    }
    dialogViewFn(tab, page);
    setOpenDrawer(true);
    handleClose();
  };

  const closeDrawer = () => {
    setOpenDrawer(false);
    setPage(0);
  };

  const handlePages = (newPage: boolean) => {
    setPage(newPage);
    dialogViewFn(0, newPage);
  };

  const [dialogView, setDialogView] = React.useState(<></>);
  const [open, setOpen] = React.useState(false);
  const location = useLocation();

  const handleMainLogo = () => {
    const skipLocation = ['/visualizer/select-tile'];
    if (skipLocation.includes(location?.pathname)) {
      navigate('visualizer');
    } else if (location?.pathname !== '/visualizer') {
      setOpen(true);
    }
  };

  const handleCloseExistModal = () => {
    setOpen(false);
  };

  const handleExist = () => {
    navigate('visualizer');
    setOpen(false);
  };

  const dialogViewFn = (tab = 0, pg = 0) => {
    if (!userData?.token) {
      return setDialogView(
        <SignIn page={pg} handlePages={handlePages} closeDrawer={closeDrawer} />,
      );
    } else {
      return setDialogView(<AccountDetails tabObj={{ tab }} closeDrawer={closeDrawer} />);
    }
  };
  const dialogTitle = (
    <Box>
      <MainLogo />
    </Box>
  );
  return (
    <Grid container direction="row">
      <Grid size={12}>
        <Grid
          container
          direction="row"
          className="header"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Grid size={6}>
            <Box onClick={handleMainLogo}>
              <MainLogo />
            </Box>
          </Grid>
          <Grid size={6}>
            <Box className="headerRightSide">
              {!userData?.token ? (
                <Button
                  onClick={() => toggleDrawer()}
                  startIcon={<AccountCircleIcon />}
                  className="NoHoverBg OrangeColor"
                >
                  Sign In
                </Button>
              ) : (
                <>
                  {' '}
                  <IconButton
                    className="AccountDetailBtn"
                    aria-describedby={id}
                    onClick={handleClick}
                  >
                    <AccountCircleIcon />
                  </IconButton>
                  <Popover
                    id={id}
                    open={opensecond}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    className="OptionsPopover"
                  >
                    <Box className="OptionsPopoverBox">
                      <List>
                        <ListItem>
                          <Typography variant="h6">{userData.user?.email}</Typography>
                        </ListItem>
                        <Divider></Divider>
                        <ListItem>
                          <Link onClick={() => toggleDrawer(0)}>
                            <AccountCircleIcon /> Account Details
                          </Link>
                        </ListItem>
                        <ListItem>
                          <Link onClick={() => toggleDrawer(1)}>
                            <TurnedInNotRoundedIcon /> Saved Scenes
                          </Link>
                        </ListItem>
                        {userData?.isAdmin && (
                          <ListItem>
                            <Link onClick={() => toggleDrawer(2)}>
                              <TrendingUpIcon /> Visualizer Analytics
                            </Link>
                          </ListItem>
                        )}
                        <Divider></Divider>
                        <ListItem>
                          <Link
                            onClick={() => {
                              logout();
                              handleClose();
                            }}
                            className="LogoutButton"
                          >
                            Log Out
                          </Link>
                        </ListItem>
                      </List>
                    </Box>
                  </Popover>
                </>
              )}
            </Box>
            <Box></Box>
          </Grid>
        </Grid>
      </Grid>
      <BottomDrawer title={dialogTitle} open={openDrawer} view={dialogView} close={closeDrawer} />
      <ExitWithoutSavingModal
        open={open}
        handleClose={handleCloseExistModal}
        onExist={handleExist}
      />
    </Grid>
  );
};

export default Header;
